import { Stack, Typography } from "@mui/material";
import MembershipDetailDependentsListV2 from ".";
import {
  IdentityDocumentType,
  MembershipStatus,
  MembershipType,
} from "../../../../services/core-api-adapter";

export default function MembershipDetailDependentsListV2Examples() {
  return (
    <Stack spacing={2}>
      <Stack>
        <Typography variant="h3" fontWeight="600">
          Main member view
        </Typography>
        <MembershipDetailDependentsListV2
          dependents={[
            {
              isPrimaryCard: true,
              membershipDetails: {
                id: "5a9e9e18-9142-44a9-8d85-0dc21759c5f0",
                type: MembershipType.MAIN_MEMBER,
                number: "UNU-725",
                status: MembershipStatus.ACTIVE,
                beneficiaryCode: "00",
              },
              memberDetails: {
                id: "7f37be7c-31dc-448b-a6b6-a9b64f1b01f2",
                memberFullName: "Susan Persona",
                identityDocumentType: IdentityDocumentType.IdNumber,
                identityDocumentValue: "6605194800082",
                dateOfBirth: "1966-05-19",
              },
            },
            {
              isPrimaryCard: false,
              membershipDetails: {
                id: "7e9fcfc7-e1de-41da-971f-4fb3100684a3",
                type: MembershipType.DEPENDENT,
                number: "UNU-722",
                status: MembershipStatus.PENDING,
                beneficiaryCode: "01",
              },
              memberDetails: {
                id: "",
                memberFullName: "Taras Shevchenko",
                identityDocumentType: IdentityDocumentType.IdNumber,
                identityDocumentValue: "8101010000002",
                dateOfBirth: "1990-01-01",
              },
            },
            {
              isPrimaryCard: false,
              membershipDetails: {
                id: "1dc8876a-d5cf-48ce-be0d-72ff952b8aba",
                type: MembershipType.DEPENDENT,
                number: "UNU-723",
                status: MembershipStatus.SUSPENDED,
                beneficiaryCode: "02",
              },
              memberDetails: {
                id: "",
                memberFullName: "Tshepo DependentMiddle-Name Maswanganyi",
                identityDocumentType: IdentityDocumentType.IdNumber,
                identityDocumentValue: "8101010000007",
                dateOfBirth: "1990-01-01",
              },
            },
          ]}
        />
      </Stack>
      <Stack>
        <Typography variant="h3" fontWeight="600">
          Adult dependent view
        </Typography>
        <MembershipDetailDependentsListV2
          dependents={[
            {
              isPrimaryCard: false,
              membershipDetails: {
                id: "9dbdde3b-bd7a-4679-bfc4-34d805dc233",
                type: MembershipType.MAIN_MEMBER,
                number: "1085123",
                status: MembershipStatus.ACTIVE,
                beneficiaryCode: "00",
              },
              memberDetails: {
                id: "261f1145-5715-4110-be82-9e61ea01123",
                memberFullName: "Denzel Ngoma",
                identityDocumentType: IdentityDocumentType.IdNumber,
                identityDocumentValue: "95012612345678",
                dateOfBirth: "1995-01-26",
              },
            },
            {
              isPrimaryCard: true,
              membershipDetails: {
                id: "790199b0-416d-4a65-96e9-3f9ce4a59c36",
                type: MembershipType.DEPENDENT,
                number: "1085123",
                status: MembershipStatus.ACTIVE,
                beneficiaryCode: "03",
              },
              memberDetails: {
                id: "ddd24955-f766-4411-af3d-7638945fc1c8",
                memberFullName: "Rugaya Ngoma",
                identityDocumentType: IdentityDocumentType.IdNumber,
                identityDocumentValue: "91103012345678",
                dateOfBirth: "1991-10-30",
              },
            },
          ]}
        />
      </Stack>
    </Stack>
  );
}
